module.exports = __webpack_public_path__ + "img/bgDiscover.68a5b835.png";